import { Injectable } from '@angular/core';
import { AnalyticsFactory } from 'src/app/ajs-upgraded-providers';
import { DisplayApiService } from 'src/app/api/services/display-api.service';
import { CompanyStateService } from 'src/app/auth/services/company-state.service';
import { UserStateService } from 'src/app/auth/services/user-state.service';
import { UserService } from 'src/app/settings/services/user.service';
import { TrackerService } from 'src/app/components/logging/tracker.service';

@Injectable({
  providedIn: 'root',
})
export class DisplayActivationService {
  constructor(
    private userStateService: UserStateService,
    private companyStateService: CompanyStateService,
    private userService: UserService,
    private analyticsFactory: AnalyticsFactory,
    private trackerService: TrackerService,
    displayApiService: DisplayApiService,
  ) {
    displayApiService.displaysLoadedSubject.subscribe((displays) => {
      this.track(displays);
    });
  }

  private _checkActiveDisplay(displays: any[]): any {
    return displays.reduce((result, display) => {
      if (!display.lastActivityDate) {
        return result;
      } else if (!result) {
        return display;
      } else {
        const newTime = new Date(display.lastActivityDate);
        const resultTime = new Date(result.lastActivityDate);
        return newTime > resultTime ? result : display;
      }
    }, null);
  }

  private _updateUserSettings(
    firstDisplayActivationDate: string,
  ): Promise<any> {
    const settings = {} as any;
    settings.firstDisplayActivationDate = firstDisplayActivationDate;

    return this.userService.updateUser(this.userStateService.getUsername(), {
      settings: settings,
    });
  }

  track(displays?: any[]): void {
    if (!displays || this.companyStateService.isSubcompanySelected()) {
      return;
    }

    const profile = this.userStateService.getCopyOfProfile();

    if (
      profile &&
      profile.settings &&
      profile.settings.firstDisplayActivationDate
    ) {
      return;
    }

    const activeDisplay = this._checkActiveDisplay(displays);

    if (activeDisplay && activeDisplay.lastActivityDate) {
      console.info('Active display found', activeDisplay);

      const activationDate = activeDisplay.lastActivityDate.toISOString();

      this.analyticsFactory.identify(this.userStateService.getUsername(), {
        firstDisplayActivationDate: activationDate,
      });

      this.trackerService.displayEvent(
        'first display activated',
        activeDisplay.id,
        activeDisplay.name,
        {
          firstDisplayActivationDate: activationDate,
        },
      );

      this._updateUserSettings(activationDate);
    }
  }
}
